/**
 * Teacher auth context — JWT in sessionStorage under 'teacher_token'.
 */
import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import { api } from "./api";

const TOKEN_KEY = "teacher_token";
const Ctx = createContext(null);

export function TeacherAuthProvider({ children }) {
  const [state, setState] = useState({ status: "loading", teacher: null, token: null });
  const signingOutRef = useRef(false);

  useEffect(() => {
    const token = sessionStorage.getItem(TOKEN_KEY);
    if (!token) {
      setState({ status: "anon", teacher: null, token: null });
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const t = await api.teacherMe(token);
        if (!cancelled) setState({ status: "auth", teacher: t, token });
      } catch {
        if (!cancelled) {
          sessionStorage.removeItem(TOKEN_KEY);
          setState({ status: "anon", teacher: null, token: null });
        }
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const value = {
    ...state,
    signingOutRef,
    setSession: (token, teacher) => {
      signingOutRef.current = false;
      sessionStorage.setItem(TOKEN_KEY, token);
      setState({ status: "auth", teacher, token });
    },
    setTeacher: (teacher) => setState((p) => ({ ...p, teacher })),
    logout: () => {
      sessionStorage.removeItem(TOKEN_KEY);
      setState({ status: "anon", teacher: null, token: null });
    },
  };
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useTeacherAuth() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useTeacherAuth outside provider");
  return ctx;
}
